import React, { Component } from "react";
import { Navbar, Nav, NavItem } from "react-bootstrap";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import * as actions from "../../actions";
import Beta from "../Beta";
import "./Header.css";

class App extends Component {
  componentDidMount() {
    const { isAuthenticated } = this.props.auth;
    if (isAuthenticated()) {
      this.props.fetchUser();
    }
  }

  goTo(route) {
    this.props.history.replace(`/${route}`);
  }

  login() {
    this.props.auth.login();
  }

  logout() {
    this.props.auth.logout();
    this.props.fetchUser();
  }

  render() {
    const { isAuthenticated } = this.props.auth;
    const { user } = this.props;
    return (
      <div className="app-header">
        <Beta />
        <Navbar fluid>
          <Navbar.Header>
            <Navbar.Brand className="app-brand-centered">
              <Link to="/">
                <img
                  src="/images/tikki-logo.png"
                  alt="Tikki"
                  className="navbar-brand-img"
                />
              </Link>
            </Navbar.Brand>
            <Navbar.Toggle />
          </Navbar.Header>
          <Navbar.Collapse>
            <Nav>
              <NavItem eventKey={1} href="/projects">
                <span>Projects</span>
              </NavItem>
              <NavItem eventKey={2} href="/about">
                <span>About</span>
              </NavItem>
            </Nav>
            <Nav pullRight>
              {isAuthenticated() && (
                <NavItem eventKey={1} href="/profile">
                  <span>
                    <img
                      className="tikki-profile-avatar responsive-img"
                      src={user.picture}
                      alt={user.name}
                    />
                  </span>
                </NavItem>
              )}
              {!isAuthenticated() && (
                <NavItem eventKey={2} href="#">
                  <span onClick={this.login.bind(this)}>Login</span>
                </NavItem>
              )}
              {isAuthenticated() && (
                <NavItem eventKey={3} href="#">
                  <span onClick={this.logout.bind(this)}>Log Out</span>
                </NavItem>
              )}
            </Nav>
          </Navbar.Collapse>
        </Navbar>
        <div className="app-footer" />
      </div>
    );
  }
}

function mapStateToProps({ user }) {
  return { user };
}

export default connect(
  mapStateToProps,
  actions
)(App);



// WEBPACK FOOTER //
// ./src/components/Header/Header.js